<template>
	<div class="user-center-container">
		<div class="user-center-content">
			<div class="tab-pane-container">
				<!-- tab头部区域--start -->
				<div class="tab-pane-header">
					<!-- tab选项 -->
					<div class="tab-pane-navs">
						<div
							v-for="(item, index) in tabs"
							:key="index"
							:class="['tab-pane-item', { active: activeTab === index }]"
							@click="activeTab = index"
						>
							{{ item.name }}
						</div>
					</div>
				</div>
				<!-- tab头部区域--end -->
				<!-- tab内容区域--start -->
				<div class="tab-pane-content">
					<!-- 已开发票区域--start -->
					<div :class="['tab-pane-content__item', { active: activeTab === 0 }]">
						<div class="search-container">
							<div class="search-form">
								<div class="form-item">
									<span class="label">订单编号</span>
									<el-input v-model="queryParams.orderCode" placeholder="请输入订单编号" clearable></el-input>
								</div>
								<div class="form-item">
									<span class="label">订单时间</span>
									<el-date-picker
										v-model="queryParams.orderTime"
										type="date"
										placeholder="选择订单时间："
										value-format="yyyy-MM-dd"
									></el-date-picker>
								</div>
								<div class="form-buttons">
									<el-button type="primary" @click="handleSearch">查询</el-button>
									<el-button @click="handleResetSearch">重置</el-button>
								</div>
							</div>
						</div>
						<!-- 已开发票列表 -->
						<div v-loading="loading" class="invoice-list">
							<template v-if="invoiceRecordList.length">
								<div v-for="(item, index) in invoiceRecordList" :key="index" class="invoice-item">
									<div class="item-header">
										<div class="order-info">
											<span class="order-no">订单号：{{ item.orderCode }}</span>
											<span class="order-time">订单时间：{{ item.orderTime }}</span>
											<span class="order-time">开票时间：{{ item.createTime }}</span>
										</div>
										<div class="invoice-status" :class="getInvoiceStateClass(item.invoiceState)">
											{{ getInvoiceStateName(item.invoiceState) }}
										</div>
									</div>
									<div class="item-content">
										<div class="invoice-info">
											<div class="info-row">
												<span class="label">套餐名称：</span>
												<span class="value">{{ item.setMealName }}</span>
											</div>
											<div class="info-row">
												<span class="label">发票类型：</span>
												<span class="value">{{ getInvoiceTypeStateName(item.invoiceType) }}</span>
											</div>
											<!-- <div class="info-row">
											<span class="label">发票金额：</span>
											<span class="value amount">￥{{ item.amount }}</span>
										</div> -->
										</div>
										<div class="action-buttons">
											<template v-if="isInvoiceCompleted(item.invoiceState)">
												<el-button type="text" @click="handleDownload(item)">下载发票</el-button>
												<el-button type="text" @click="handleView(item)">查看发票</el-button>
											</template>
										</div>
									</div>
								</div>
							</template>

							<!-- 数据为空 -->
							<empty-content v-else empty-text="暂无开票信息"></empty-content>

							<!-- 分页 -->
							<div v-if="invoiceRecordList.length" class="pagination-container">
								<jr-pagination
									:limit="pageOptions.limit"
									:page.sync="pageOptions.page"
									:total="pageOptions.total"
									layout="prev, pager, next"
									prev-text="上一页"
									next-text="下一页"
									@change="handlePaginationChange"
								></jr-pagination>
							</div>
						</div>
					</div>
					<!-- 已开发票区域--end -->
					<!-- 发票信息--start -->
					<div :class="['tab-pane-content__item', { active: activeTab === 1 }]">
						<div class="invoice-form-container">
							<div class="form-content">
								<el-form ref="invoiceForm" :model="invoiceForm" :rules="rules" label-width="140px">
									<el-form-item label="开票类型：" prop="invoiceType" class="form-item">
										<el-radio-group v-model="invoiceForm.invoiceType">
											<el-radio label="0">增值税普通发票</el-radio>
											<el-radio label="1">增值税专用发票</el-radio>
										</el-radio-group>
									</el-form-item>
									<el-form-item label="抬头类型：" prop="headType" class="form-item">
										<el-radio-group v-model="invoiceForm.headType">
											<el-radio label="0">企业</el-radio>
											<el-radio label="1">个人</el-radio>
										</el-radio-group>
									</el-form-item>
									<template v-if="invoiceForm.headType === '0'">
										<el-form-item label="企业名称：" prop="taxpayer" class="form-item">
											<el-input v-model="invoiceForm.taxpayer" placeholder="请输入企业名称"></el-input>
										</el-form-item>
										<el-form-item label="纳税人识别号：" prop="taxpayerCode" class="form-item">
											<el-input v-model="invoiceForm.taxpayerCode" placeholder="请输入纳税人识别号"></el-input>
										</el-form-item>
										<el-form-item label="企业注册地址：" prop="companyAddr" class="form-item">
											<el-input v-model="invoiceForm.companyAddr" placeholder="请输入企业注册地址"></el-input>
										</el-form-item>
										<el-form-item label="企业注册电话：" prop="companyPhone" class="form-item">
											<el-input v-model="invoiceForm.companyPhone" placeholder="请输入企业注册电话"></el-input>
										</el-form-item>
										<el-form-item label="开户银行：" prop="bankName" class="form-item">
											<el-input v-model="invoiceForm.bankName" placeholder="请输入开户银行"></el-input>
										</el-form-item>
										<el-form-item label="银行账号：" prop="bankCode" class="form-item">
											<el-input v-model="invoiceForm.bankCode" placeholder="请输入银行账号"></el-input>
										</el-form-item>
									</template>
									<template v-else-if="invoiceForm.headType === '1'">
										<el-form-item label="发票抬头：" prop="taxpayer" class="form-item">
											<el-input v-model="invoiceForm.taxpayer" placeholder="请输入个人或姓名"></el-input>
										</el-form-item>
									</template>

									<div class="form-tips">
										<p>
											提示：请按照电子商务法及发票管理办法等相关规定填写发票信息，若因填写无效信息或非法信息等造成包括但不限于无法成功开具发票等后果或法律责任，由您自行承担。
										</p>
									</div>
								</el-form>

								<div class="form-button-group">
									<el-button
										:loading="submitLoading"
										type="primary"
										class="form-button form-button--primary"
										@click="handleSaveUserInvoiceHeadInfo"
									>
										保存
									</el-button>
								</div>
							</div>
						</div>
					</div>
					<!-- 发票信息--end -->
				</div>
				<!-- tab内容区域--end -->
			</div>
		</div>
	</div>
</template>

<script>
	import JrPagination from '@/components/Pagination'
	import { queryInvoiceRecordPager, saveUserInvoiceInfo } from '@/api/memberBenefit/index'
	import { getUserInfo } from '@/api/userCenter/index'
	import { ENUM_INVOICE_STATE, INVOICE_STATE, INVOICE_STATE_CLASS, ENUM_INVOICE_TYPE_STATE } from '@/enum/index'
	import { downloadFileRecord, previewFileRecord } from '@/api/memberBenefit'
	import { getToken } from '@/utils/auth'

	// 我的发票
	export default {
		name: 'InvoiceList',
		components: {
			JrPagination
		},
		props: {},
		data() {
			return {
				// 当前激活的选项
				activeTab: 0,
				// tab选项
				tabs: [{ name: '已开发票' }, { name: '发票信息' }],
				// 搜索参数
				queryParams: {
					orderCode: '',
					orderTime: ''
				},
				// 分页配置
				pageOptions: {
					limit: 3,
					page: 1,
					total: 0
				},
				// 加载状态
				loading: false,
				// 提交加载状态
				submitLoading: false,
				// 发票记录
				invoiceRecordList: [],
				// 发票抬头信息
				invoiceForm: {
					// 开票类型（0增值税普通发票，1增值税专用发票）
					invoiceType: '',
					// 抬头类型（0企业，1个人）
					headType: '',
					// 企业名称
					taxpayer: '',
					// 纳税人识别号
					taxpayerCode: '',
					// 企业注册地址
					companyAddr: '',
					// 企业注册电话
					companyPhone: '',
					// 开户银行
					bankName: '',
					// 银行账号
					bankCode: ''
				},
				rules: {
					invoiceType: [{ required: true, message: '请选择开票类型', trigger: 'change' }],
					headType: [{ required: true, message: '请选择抬头类型', trigger: 'change' }],
					taxpayer: [{ required: true, message: '请输入纳税人名称', trigger: 'blur' }],
					taxpayerCode: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
					companyAddr: [{ required: false, message: '请输入企业注册地址', trigger: 'blur' }],
					companyPhone: [{ required: false, message: '请输入企业注册电话', trigger: 'blur' }],
					bankName: [{ required: false, message: '请输入开户银行', trigger: 'blur' }],
					bankCode: [{ required: false, message: '请输入银行账号', trigger: 'blur' }]
				}
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.handleGetMyInvoiceRecordList()
			this.handleQueryMyInvoiceHeadInfo()
		},
		methods: {
			// 获取开票状态名称
			getInvoiceStateName(state) {
				return ENUM_INVOICE_STATE[state] || '未知状态'
			},

			// 获取开票状态对应的CSS类名
			getInvoiceStateClass(state) {
				return INVOICE_STATE_CLASS[state] || ''
			},

			// 判断发票是否为待开票状态
			isInvoicePending(state) {
				return Number(state) === INVOICE_STATE.PENDING
			},

			// 判断发票是否为已开票状态
			isInvoiceCompleted(state) {
				return Number(state) === INVOICE_STATE.COMPLETED
			},

			// 判断发票是否为开票中状态
			isInvoiceProcessing(state) {
				return Number(state) === INVOICE_STATE.PROCESSING
			},

			// 获取开票类型名称
			getInvoiceTypeStateName(state) {
				return ENUM_INVOICE_TYPE_STATE[state] || '未知状态'
			},

			// 查询我的开票记录
			handleGetMyInvoiceRecordList() {
				this.loading = true
				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					...this.queryParams
				}

				queryInvoiceRecordPager(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.invoiceRecordList = data.records || []
							this.pageOptions.total = data.total || 0
						} else {
							this.invoiceRecordList = []
							this.total = 0
						}
						this.loading = false
					})
					.catch(() => {
						this.loading = false
						this.invoiceRecordList = []
						this.total = 0
					})
			},

			// 分页
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.handleGetMyInvoiceRecordList()
			},

			// 搜索
			handleSearch() {
				this.pageOptions.page = 1
				this.pageOptions.limit = 3
				this.handleGetMyInvoiceRecordList()
			},

			// 重置搜索
			handleResetSearch() {
				this.queryParams = {
					orderCode: '',
					orderTime: ''
				}
				this.handleGetMyInvoiceRecordList()
			},

			// 查询我的发票抬头信息
			handleQueryMyInvoiceHeadInfo() {
				const params = {
					// 仅获取iuserinfo表主要返回开票配置信息
					type: 'invoiceInfo'
				}
				getUserInfo(params)
					.then(response => {
						const { data } = response
						if (data) {
							this.invoiceForm = {
								invoiceType: data.invoiceType,
								headType: data.headType,
								taxpayer: data.taxpayer,
								taxpayerCode: data.taxpayerCode,
								companyAddr: data.companyAddr,
								companyPhone: data.companyPhone,
								bankName: data.bankName,
								bankCode: data.bankCode
							}
						}
					})
					.catch(() => {})
			},

			// 保存用户的发票抬头信息
			handleSaveUserInvoiceHeadInfo() {
				this.submitLoading = true
				this.$refs.invoiceForm.validate(valid => {
					if (valid) {
						saveUserInvoiceInfo(this.invoiceForm)
							.then(() => {
								this.$message.success('保存成功')
								this.submitLoading = false
							})
							.catch(() => {
								this.$message.error('保存失败')
								this.submitLoading = false
							})
					} else {
						this.submitLoading = false
						return false
					}
				})
			},

			handleInvoice(item) {
				// 处理开具发票
			},
			handleDownload(item) {
				// 处理下载发票
				window.open(downloadFileRecord({ fileRecordId: item.fileId, InternetToken: getToken() }), '_blank')
			},
			handleView(item) {
				console.log('handleView')
				// 处理查看发票
				window.open(previewFileRecord({ fileRecordId: item.fileId, InternetToken: getToken() }), '_blank')
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/tab-pane.scss';
	@import '~@/views/user/styles/user-center.scss';
	@import '~@/styles/element-reset.scss';

	.invoice-list {
		.invoice-item {
			border: 1px solid #ebeef5;
			border-radius: 8px;
			margin-bottom: 20px;
			transition: all 0.3s;

			&:hover {
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
				transform: translateY(-2px);
			}

			.item-header {
				padding: 15px 20px;
				background: #fafafa;
				border-radius: 8px 8px 0 0;
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #ebeef5;

				.order-info {
					.order-no {
						font-weight: 500;
						margin-right: 20px;
					}

					.order-time {
						color: #909399;

						& + .order-time {
							margin-left: 30px;
						}
					}
				}

				.amount {
					color: #f56c6c;
					font-size: 18px;
					font-weight: 500;
				}

				.invoice-status {
					padding: 4px 12px;
					border-radius: 15px;
					font-size: 14px;

					&.pending {
						color: #e6a23c;
						background: #fdf6ec;
					}

					&.completed {
						color: #67c23a;
						background: #f0f9eb;
					}

					&.processing {
						color: #909399;
						background: #f4f4f5;
					}
				}
			}

			.item-content {
				padding: 20px;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.product-info {
					.name {
						font-size: 16px;
						color: #303133;
						margin-bottom: 8px;
					}

					.desc {
						color: #909399;
						font-size: 14px;
					}
				}

				.invoice-info {
					.info-row {
						margin-bottom: 8px;

						&:last-child {
							margin-bottom: 0;
						}

						.label {
							color: #909399;
							margin-right: 8px;
						}

						.value {
							color: #303133;

							&.amount {
								color: #f56c6c;
								font-weight: 500;
							}
						}
					}
				}

				.action-buttons {
					.el-button {
						padding: 0;
						margin-left: 15px;

						&:first-child {
							margin-left: 0;
						}
					}
				}
			}
		}
	}

	.invoice-form-container {
		padding: 0 30px;

		.form-content {
			.form-item {
				::v-deep {
					.el-input {
						input {
							padding: 0 15px 0 15px;
						}
					}
				}
			}
		}
	}
</style>
